import React from 'react';
import TradeDelete from '../components/TradeDelete';

const DeleteTrade = () => (
  <>
    <TradeDelete />
  </>
);

export default DeleteTrade;
